import { Box, styled } from "@mui/material";
/* eslint-disable no-unused-vars */
import { CreateProfileFormType, CreateProfileSchema } from "../../services/user-create/user-create.schema";
import { GvInputController, GvInputMaskController, GvSelectController } from "../Controllers";
import React, { useEffect, useState } from "react";

import GvAutocompleteLocationSearch from "../GvAutocompleteLocationSearch/GvAutocompleteLocationSearch";
import GvPrimaryButton from "../GvPrimaryButton/GvPrimaryButton";
import { ILocationSearchPrediction } from "../../services/location/location.interface";
import { getPhonePattern } from "../../utils";
import { useForm } from "react-hook-form";
import { useFormattedLocation } from "../../services/location/location.service";
import { useGTM } from "../../hooks/useGTM";
import { useSurveyCustomerFeedback } from "../../services/survey-customer-feedback/survey-customer-feedback.service";
import { useUserStore } from "../../hooks/redux-hooks/user-store/user.store";
import { yupResolver } from "@hookform/resolvers/yup";

interface IAddPersonalDetailsForm {
  onSubmitStep1: (data: any) => void;
  personalDetails: any;
}

export const FlexStyleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const GvAddPersonalDetailForm: React.FC<IAddPersonalDetailsForm> = ({ onSubmitStep1, personalDetails }) => {
  const { user } = useUserStore();
  const { list, loading } = useSurveyCustomerFeedback();
  const [optionSelected, setOptionSelected] = useState<string | undefined>();
  const [showAddressFields, setShowAddressFields] = useState<boolean>(false);
  const isPhoneAlreadyEnabled = user?.fireBasePhone ? true : false;

  const { control, setError, clearErrors, handleSubmit, watch, setValue, getValues, trigger,
    formState: { errors } } = useForm<CreateProfileFormType>({
      mode: "onChange",
      resolver: yupResolver(CreateProfileSchema),
      defaultValues: {
        firstName: personalDetails? personalDetails.firstName : "",
        lastName: personalDetails ? personalDetails.lastName : "",
        phone: user?.fireBasePhone ? getPhonePattern(user?.fireBasePhone) : personalDetails ?
          personalDetails.phone : "",
        email: user ? user.email : "",
        setphoneforlogin: isPhoneAlreadyEnabled || false,
        otp: null,
        channelFoundUs: personalDetails ? personalDetails.channelFoundUs : undefined,
        location: null,
        contactId: null,
        placeId: null,
        address: "",
        streetAddress: personalDetails? personalDetails.streetAddress : "",
        country: "",
        townCity: personalDetails? personalDetails.townCity : "",
        zipCode: personalDetails? personalDetails.zipCode : "",
        countryCode: "+1",
      },
    });

  const { findFormatedLoction, searchData } = useFormattedLocation();
  const { dispatchEvent } = useGTM();

  const handleEmailInputBlur = () => {
    setValue("email", getValues("email").trim().toLowerCase());
  };


  const handleLocationSearch = (place: ILocationSearchPrediction) => {
    setValue("placeId", place?.place_id || "");
    findFormatedLoction(place?.place_id || "");
    setValue("address", place?.description || "");
    if (getValues("placeId")) {
      setShowAddressFields(true);
    }
    dispatchEvent({
      eventName: "gv_choose_address",
      eventProps: {
        addressValue: place.description,
      },
    });
  };


  const handleToggleLoctionsFields = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    setShowAddressFields(!showAddressFields);
  };


  useEffect(() => {
    if (searchData) {
      setValue("streetAddress", searchData?.streetAddress, { shouldValidate: true });
      setValue("townCity", searchData?.townCity, { shouldValidate: true });
      setValue("zipCode", searchData?.zipCode, { shouldValidate: true });
      setValue("country", "US", { shouldValidate: false });
      clearErrors(["address"]);
    }
  }, [searchData]);

  useEffect(() => {
    if (personalDetails) {
      setValue("placeId", personalDetails.placeId);
      setValue("address", personalDetails.address);
    }
  }, []);


  return (
    <form onSubmit={handleSubmit(onSubmitStep1)} className="h-full grow shrink-0 overflow-scroll scroll-hide mt-0">

      <div className="mb-2 overflow-hidden">

        <GvInputController
          control={control}
          name="firstName"
          label="First name"
          placeholder="Michael"
        />
        <GvInputController
          control={control}
          name="lastName"
          label="Last name"
          placeholder="Smith"
        />

        <GvInputMaskController
          control={control}
          name="phone"
          label="Phone Number"
          mask="999-999-9999"
          placeholder="XXX-XXX-XXXX"
        />


        <GvInputController
          control={control}
          name="email"
          label="Email address"
          disabled={!!user}
          placeholder="Enter your email"
          onBlur={handleEmailInputBlur}
        />
        <GvAutocompleteLocationSearch
          searchValue={personalDetails ? personalDetails.address : ""}
          isExpandIcon={false}
          disable={true}
          setShowAddressFields={setShowAddressFields}
          onSelect={handleLocationSearch}
          expand={showAddressFields}
          handleToggleLoctionsFields={handleToggleLoctionsFields}
          label="Enter Your Address"
          control={control}
        />
        {(showAddressFields || window.innerWidth>1280) && (
          <>
            <GvInputController
              control={control}
              name="streetAddress"
              label="Street address"
              placeholder="Enter Street Address"
            />
            <GvInputController
              control={control}
              name="townCity"
              label="Town/City"
              placeholder="Enter Town/City"
            />
            <GvInputController
              control={control}
              name="zipCode"
              label="Zip Code"
              placeholder="Enter Zip Code"
            />
          </>
        )}
        <GvSelectController
          isLoading={loading}
          control={control}
          name="channelFoundUs"
          label={list[0]?.name}
          placeholder="Choose an option"
          options={list[0]?.options}
        />
        {optionSelected === "Other" && (
          <GvInputController
            control={control}
            name="tellUsMore"
            label="Tell us more"
            placeholder="Type something..."
            multiline={true}
          />
        )}
      </div>

      <div className="sticky bottom-0 py-2 z-[1000] bg-[#F9F6F4] ">
        <GvPrimaryButton type="submit" className="" >Next</GvPrimaryButton>
      </div>
    </form>
  );
};

export default GvAddPersonalDetailForm;
